/* eslint-disable camelcase */
import { requestJSON } from './request'
import { ProfileMembership } from './profile'
import { BookmarkApi } from './bookmarks'

export interface User {
  pk: number
  username: string
  first_name: string
  last_name: string
  forum_user: ForumUser
  bookmarks: BookmarkApi[]
}

export interface ForumUser {
  id: number
  user: number
  first_name: string
  last_name: string
  avatar: string
  avatar_url: string
  biography: string
  date_modified: string | null
  is_premium: boolean
  is_internal_user: boolean
  vip: boolean
  notify_updated_contents: boolean
  notify_new_project_discussion_threads: boolean
  has_newsletter_subscription: boolean
  memberships: ProfileMembership[]
}

export async function getUser (userId: number): Promise<User> {
  const url = new URL(`/api/user/${userId}/`, window.location.href)
  return await requestJSON(url.toString())
}

export async function getForumUserAbortable (profileId: number, controller: AbortController): Promise<ForumUser> {
  const url = new URL(`/api/profile/${profileId}/`, window.location.href)
  return await requestJSON(url.toString(), { signal: controller.signal })
}
